<template>
  <div>
    <h1>Lista de Concedentes</h1>

    <b-card>
      <div class="d-flex mb-2">
        <div class="w-75 mr-auto">
          <b-input-group size="sm">
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="searchTerm"
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="searchTerm" variant="exitos">Buscar</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <b-button
            variant="exitos"
            :to="{ name: 'concedentes_create' }"
            v-if="$can('concedente:create')"
          >
            <font-awesome-icon icon="plus" />
            Novo Concedente
          </b-button>
        </div>
      </div>

      <b-table
        striped
        hover
        :items="concedentes"
        :fields="fields"
        :busy="isBusy"
        @sort-changed="sortingChanged"
        show-empty
        sort-icon-left
      >
        <template #cell(endereco)="{ item }">
          <CellEndereco
            :endereco="item.endereco"
            :sem_endereco="item.sem_endereco"
          />
        </template>
        <template #cell(contatos)="{ item }">
          <CellContatos v-if="item.contatos" :contatos="item.contatos" />
        </template>
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('concedente:edit')"
            :view_delete="$can('concedente:delete')"
            edit_to="concedentes_edit"
            @delete="deleteItem"
            :delete_infors="oportunidadesInfors(row.item.oportunidades_count)"
          />
        </template>

        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>

        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </b-card>

    <div>
      <pagination-nav :pagination="pagination" @input="loadData()" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import mixins from "@/components/Table/mixins";

export default {
  mixins: [mixins],

  computed: {
    ...mapState("concedentes", ["concedentes", "pagination"]),

    fields() {
      return [
        { key: "id", label: "COD", class: "col-1", sortable: true },
        { key: "nome", label: "nome", sortable: true },
        {
          key: "concedente_tipo.nome",
          label: "Origem",
          class: "col-2",
          sortable: true,
        },

        { key: "contatos", label: "Formas de Contato", class: "col-1" },
        {
          key: "ultima_atualizacao",
          label: "Última Atualização",
          class: "col-1",
          sortable: true,
          formatter: (value, head, object) => {
            return this.$options.filters.humanize_datetime(value);
          },
        },
        {
          key: "concedente_contatos_count",
          label: "Número de Contatos",
          class: "col-1",
        },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    ...mapActions("concedentes", ["ActionGetAll", "ActionDelete"]),
    oportunidadesInfors(oportunidades_count) {
      if (oportunidades_count)
        return `Essa concedente possui ${oportunidades_count} oportunidade(s) vinculada(s) a ela, você tem certeza que deseja excluir?`;
      return "";
    },
  },
  async created() {
    if (this.$route.query.page > 1) {
      this.page = this.$route.query.page;
    }
    if (this.$route.query.q != "") {
      this.termo_pesquisa = this.$route.query.q;
    }
    this.loadData();
  },
};
</script>
